import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChangePlanSummaryDialogData, PlanInterval, SubscriptionLicense } from '../../../shared/models/plans';

@Component({
  selector: 'cc-change-plan-summary',
  templateUrl: './change-plan-summary-dialog.component.html',
  styleUrls: ['./change-plan-summary-dialog.component.scss']
})
export class ChangePlanSummaryDialogComponent implements OnInit {
  public currentSubscription: SubscriptionLicense;
  public totalPrice: number;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ChangePlanSummaryDialogData) {
    this.currentSubscription = this.data.currentSubscription.licenses[0];
  }

  ngOnInit() {
    if (this.data.numberOfUsers > this.data.newPlan.usersIncluded) {
      this.totalPrice =
        this.priceInDollar(this.data.newPlan.flatPriceCents) +
        this.priceInDollar(
          this.data.newPlan.pricePerUserCents * (this.data.numberOfUsers - this.data.newPlan.usersIncluded)
        );
    } else {
      this.totalPrice = this.priceInDollar(this.data.newPlan.flatPriceCents);
    }
  }

  public priceInDollar(priceInCents: number): number {
    return Math.round(priceInCents / 100);
  }

  public usersNumber(numberOfUsers: number, usersMinimum: number) {
    if (numberOfUsers < usersMinimum) {
      return usersMinimum;
    } else {
      return numberOfUsers;
    }
  }

  public newPlanPrice() {
    const newPlan = this.data.newPlan;
    const additionalUsers = Math.max(0, this.data.numberOfUsers - newPlan.usersIncluded);
    return newPlan.flatPriceCents + newPlan.pricePerUserCents * additionalUsers;
  }
}
